import type { Brand, BrandInput } from '@shop-monorepo/types';
import React from 'react';

import { useUpdateBrand } from '../../hooks/useBrandQueries';
import { useListReturn } from '../../hooks/useListReturn';
import { ROUTES } from '../../routes/routes';

import { BrandForm } from './BrandForm';

interface EditBrandFormProps {
  brand: Brand;
}

export const EditBrandForm: React.FC<EditBrandFormProps> = ({ brand }) => {
  const { goToList } = useListReturn(ROUTES.BRANDS);
  const { mutate: updateBrand, isPending: isSubmitting } = useUpdateBrand();

  const handleSubmit = async (values: BrandInput) => {
    updateBrand(
      { id: brand.id, brand: values },
      {
        onSuccess: () => {
          goToList();
        },
      },
    );
  };

  return <BrandForm initialValues={brand} onSubmit={handleSubmit} isSubmitting={isSubmitting} />;
};
